// Payment Messages
export const RUPEE_SYMBOL = '₹'
export const PAYMENT_SUCCESSFUL = amount =>
  `Payment of ${RUPEE_SYMBOL}${amount} is successful.`;
export const PARTIAL_COD = amount =>
  `Pay ${RUPEE_SYMBOL}${amount} at the time of delivery to the rider.`;
export const PARTIAL_POD = amount =>
  ` Payment of ${RUPEE_SYMBOL}${amount} is pending. Pay Now!`;
export const HB_PRIME = `Your VXL membership is Subscribed Successfully.`;
export const HB_POINT = `Your order is successfully placed.`;
